export default {
  name: "success-register-agent",
  created() {
    document.getElementById("html").classList.add("hide");
  },
};
